/* global process */
let base = window._env_.VUE_APP_ADMIN_HOST
export const getFlBannerTable = params => {
  return axios.post(`${base}/query_flbanner`, params)
}
export const deleteFlBanner = id => {
  return axios.post(`${base}/delete_flbanner_${id}`)
}
export const createFlBanner = params => {
  return axios.post(`${base}/create_flbanner`, params)
}
export const editFlBanner = params => {
  return axios.post(`${base}/edit_flbanner_${params.id}`, params)
}
export const getFlBanner = id => {
  return axios.get(`${base}/flbanner_${id}`)
}
export const uploadFlBanner = params => {
  return axios.post(`${base}/flbanner_upload_file`, params)
}
export const getFlBannerLogTable = params => {
  return axios.post(`${base}/query_flbanner_log`, params)
}



// WEBPACK FOOTER //
// ./src/views/flbanner/flbanner.api.js